module.exports = __webpack_public_path__ + "media/images/alex-beta-imagery-1cf123b8.png";